import { Box, Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { UserDataInOrganization } from '../components/organization/card';
import { FormSkeleton } from '../components/skeleton';
import { useIdentifyUserAndPage } from '../hooks/useIdentifyUserAndPage';
import { useUserStore } from '../stores/userStore';
import { PageName } from '../utils/locale/identifyUserAndPage';

export const UserForm = () => {
    const me = useUserStore((state) => state.me);
    const intl = useIntl();
    useIdentifyUserAndPage(me?._id, PageName.personalData, me?.email);

    if (!me) {
        return <FormSkeleton />;
    }

    const textSx = {
        padding: 3,
        mt: 8,
        display: 'flex',
        justifyContent: 'center',
    };
    if (me?.basePermissions?.role === 'superadmin') {
        return (
            <Box sx={textSx}>
                <Typography>Not supported for superadmin</Typography>
            </Box>
        );
    }
    if (me.personalData.length === 0) {
        return (
            <Box sx={textSx}>
                <Typography>
                    {intl.formatMessage({ id: 'empty_personal_data_view' })}
                </Typography>
            </Box>
        );
    }
    return (
        <Box sx={{ padding: 3, mt: 6 }}>
            <Grid container spacing={2}>
                {me?.personalData.map(({ label, phone, encryptedClientId }) => (
                    <Grid item xs={12} md={6} key={encryptedClientId}>
                        <UserDataInOrganization
                            label={label}
                            phone={phone}
                            encryptedClientId={encryptedClientId}
                            userId={me._id}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
